/**
 * 工伤确认单
 */

import {
  get,
  post,
  put,
  del
} from '@/util/request'
import download from "@/util/download";

/**
 * 根据Id查询
 * @param {*} data
 * @returns
 */
export const SelectInjuryAffirmBillById = (Id) => {
  return get('/api/app/injuryAffirmBill?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddInjuryAffirmBill = (data) => {
  return post('/api/app/injuryAffirmBill', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyInjuryAffirmBill = (data) => {
  return put('/api/app/injuryAffirmBill', data, {});
}

/**
 * 分页获取
 * @param {*} data
 * @returns
 */
export const GetDataInjuryAffirmBillList = (data) => {
  return post('/api/app/injuryAffirmBill/list', data, {});
}

/**
 * 链表分页获取
 * @param {*} data
 * @returns
 */
 export const GetDataInjuryAffirmBillListByPageQuery = (data) => {
  return post('/api/app/injuryAffirmBill/getDataByPageQuery', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteInjuryAffirmBill = (id) => {
  return del('/api/app/injuryAffirmBill/' + id, {}, {});
}

/**
 * 导出Excel
 * @param {*} id
 * @returns
 */
 export const ExportInjuryAffirmBill = (data,title) => {
  let defaluturl = `/api/app/injuryAffirmBill/exportExcelFile`;
  let fileName = "工伤认定单"
  if(title) {
    fileName = title;
  }
  return download(fileName, defaluturl, data);
}

/**
 * 折线图 按年,返回的是每年12个月的数据
 * @param {*} data
 * @returns
 */
export const SelectTJByYear = (data) => {
  return post("/api/GSRDD/SelectTJByYear", data, {});
}
/**
 * 饼图按行业
 * @param {*} data
 * @returns
 */
export const SelectTJByHY = (data) => {
  return post("/api/GSRDD/SelectTJByHY", data, {});
}
/**
 * 柱状图 按受伤部位
 * @param {*} data
 * @returns
 */
export const SelectTJBySSBW = (data) => {
  return post("/api/GSRDD/SelectTJBySSBW", data, {});
}

/**
 * 1.工伤事故发展趋势统计分析
 * @param {*} data
 * @returns
 */
export const GetInjuryDevelopmentTrendAlysisData = (data) => {
  return post('/api/app/injuryAffirmBill/getInjuryDevelopmentTrendAlysisData', data, {});
}

/**
 * 2.年度死亡人数分析
 * @param {*} data
 * @returns
 */
 export const GetInjuryDeadthAlysisData = (data) => {
  return post('/api/app/injuryAffirmBill/getInjuryDeadthAlysisData', data, {});
}

/**
 * 3.工伤事故发生月份情况
 * @param {*} data
 * @returns
 */
 export const GetInjuryMonthAlysisData = (data) => {
  return post('/api/app/injuryAffirmBill/getInjuryMonthAlysisData', data, {});
}

/**
 * 4.工伤事故季度情况
 * @param {*} data
 * @returns
 */
 export const GetInjuryQuarterAlysisData = (data) => {
  return post('/api/app/injuryAffirmBill/getInjuryQuarterAlysisData', data, {});
}

/**
 * 5.工伤事故行业分析
 * @param {*} data
 * @returns
 */
 export const GetInjuryTypeAlysisData = (data) => {
  return get('/api/app/injuryAffirmBill/injuryTypeAlysisData', data, {});
}

/**
 * 6.主要伤害类型分析 比如爆炸伤害
 * @param {*} data
 * @returns
 */
 export const GetInjuryPartAlysisData = (data) => {
  return get('/api/app/injuryAffirmBill/injuryPartAlysisData', data, {});
}

/**
 * 7.受伤人群性别分析
 * @param {*} data
 * @returns
 */
 export const GetInjurySexAlysisData = (data) => {
  return get('/api/app/injuryAffirmBill/injurySexAlysisData', data, {});
}

/**
 * 8.年龄阶段分析
 * @param {*} data
 * @returns
 */
 export const GetInjuryAgeAlysisData = (data) => {
  return get('/api/app/injuryAffirmBill/injuryAgeAlysisData', data, {});
}

/**
 * 9.工伤等级分析
 * @param {*} data
 * @returns
 */
 export const GetOccupationalInjuryLevelAlysisData = (data) => {
  return post('/api/app/injuryAffirmBill/getOccupationalInjuryLevelAlysisData', data, {});
}

/**
 * 10.伤害部位分析
 * @param {*} data
 * @returns
 */
 export const GetInjurySiteAlysisData = (data) => {
  return post('/api/app/injuryAffirmBill/getInjurySiteAlysisData', data, {});
}

/**
 * 11.企业工伤数据分析
 * @param {*} data
 * @returns
 */
 export const GetInjuryUnitAlysisData = (data) => {
  return post('/api/app/injuryAffirmBill/getInjuryUnitAlysisData', data, {});
}

/**
 * 12.职业病工伤数据分析
 * @param {*} data
 * @returns
 */
 export const GetOccupationDiseaseData = (data) => {
  return post('/api/app/injuryAffirmBill/getOccupationDiseaseData', data, {});
}

/**
 * 获取工伤单中岗位数据
 * @param {*} data
 * @returns
 */
 export const GetInjuryPostData = () => {
  return get('/api/app/injuryAffirmBill/injuryPostData', {}, {});
}